import React, { useEffect } from "react";

import {
  RouterProvider,
} from "react-router-dom";
import router from "./routes";
import ReactGA from "react-ga4";

function App() {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_ANALYTICS_MEASUREMENT_ID);
  },[]);

  return (
    <React.Fragment>
      <RouterProvider router={router} />
    </React.Fragment>
  );
}

export default App;
